import client from '../../../base-api';

const serviceURL = '/analytics/unemployed-details-overview';

const analyticsUnemployedDetailsOverviewService = {

    getAllUnemployed(filterData: any) {
        return client.get(`${serviceURL}/unemployed-list`, {params: filterData});
    },
    getCoachingListForUnemployed(unemployedId: number) {
        return client.get(`${serviceURL}/coaching-list/${unemployedId}`);
    },

    getPrivateCoachingDetails(id: number) {
        return client.get(`${serviceURL}/private-coaching-details/${id}`);
    },
    getGroupCoachingDetails(id: number) {
        return client.get(`${serviceURL}/group-coaching-details/${id}`);
    },
    getSocioTherapyCoachingDetails(id: number) {
        return client.get(`${serviceURL}/socio-therapy-coaching-details/${id}`);
    },
    getCaseManagementCoachingDetails(id: number) {
        return client.get(`${serviceURL}/case-management-coaching-details/${id}`);
    },
    getAssistedLivingCoachingDetails(id: number) {
        return client.get(`${serviceURL}/assisted-living-coaching-details/${id}`);
    }
}

export default analyticsUnemployedDetailsOverviewService;